export const MENU_LAYOUTS = {
    BURGER: "burguer",
    ICONS: "icons",
    DEFAULT: "default",
    CP: "cp",
};